import { render } from "./NewsMenu.vue?vue&type=template&id=747cfdfe&scoped=true"
import script from "./NewsMenu.vue?vue&type=script&lang=js"
export * from "./NewsMenu.vue?vue&type=script&lang=js"

import "./NewsMenu.vue?vue&type=style&index=0&id=747cfdfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747cfdfe"]])

export default __exports__